import {
  GoalOutcomeOptions,
  GoalReviewStatusOptions,
} from "@coaching-culture/types";
import { Label } from "@coaching-culture/ui";
import { IconType } from "react-icons";
import { FaFrown, FaGrinWink, FaSmile, FaThumbsUp } from "react-icons/fa";
import styled from "styled-components";

/** Status pill colours; undefined is the neutral label. */
const levels: { value: string; text: string; color?: string }[] = [
  { value: "blocked", text: "Blocked", color: "danger" },
  { value: "onhold", text: "On Hold" },
  { value: "achieved", text: "Achieved", color: "positive" },
  { value: "inprogress", text: "In Progress", color: "warning" },
  { value: "notstarted", text: "Not Started" },
];

const icons: Record<string, IconType> = {
  exceeded: FaGrinWink,
  achieved: FaThumbsUp,
  notstarted: FaFrown,
  inprogress: FaSmile,
  onhold: FaGrinWink,
  blocked: FaFrown,
};

const Container = styled.span<{ clickable: boolean }>`
  display: inline-flex;
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};
  user-select: none;
`;

export type GoalProgressSelectProps = {
  value: GoalReviewStatusOptions | GoalOutcomeOptions;
  onClick?: () => void;
  disabled?: boolean;
};

export function GoalProgressDisplay({
  value,
  disabled,
  onClick,
}: GoalProgressSelectProps) {
  const currentLevel = levels.find((level) => level.value === value);

  return (
    <Container
      clickable={onClick != null}
      onClick={onClick}
      style={{
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Label color={currentLevel?.color} icon={icons[value]}>
        {currentLevel?.text}
      </Label>
    </Container>
  );
}
